<template>
  <div class='exchangeDetail'>
    <section class="section detail-section centerbox columnbox report-detail">
      <div class="content centerbox columnbox w1200">
        <h2 style="text-align: center;">{{ content.title }}</h2>
        <label>{{ content.time }}</label>

        <p style="text-align: center;" class="videoDiv">
          <!-- width="760" height="395" -->
          <video class="edui-upload-video  vjs-default-skin video-js" poster="../../assets/images/video.png" controls="" preload="none"  :src="content.videoUrl">
            <source :src="content.videoUrl" type="video/mp4">
          </video>
        </p>

      </div>
      <div class="bottom-slide w1200 betweenbox">
        <div class="link-ul flexbox align-start">
          <a class="return-a" @click="backList()">返回列表</a>
          <a v-if="content.next != '无'" class="next-a" @click="goNext(content.next)">下一篇:{{ content.next }}</a>
        </div>
        <a :href="content.download" class="down-a flexbox">&ensp;文章下载</a>
      </div>
    </section>

  </div>
</template>

<script>
import axios from 'axios'
export default {
  metaInfo() {
    return {
      title: "整合多种来源的真实世界患者数据-健新",
      meta: [
        { name: "keywords", content: "keyword1, keyword2, keyword3" },
        { name: "description", content: "Page description" },
      ],
    };
  },
  mounted() {

  },
  data() {
    return {
      content:{}
    }
  },
  created() {
    let data = {
        Title: this.$route.query.title,
        ForumTypeCode: "YCXSYJ",
      };
    this.getExchangeList(data)
  },
  // 监听导航下拉回收
  watch: {
  },
  methods: {
    getExchangeList(data){
      axios
        .post("api/Forum/GetDoc", { ...data })
        .then((res) => {
          if (res) {
           this.content = JSON.parse(res.data.OutputData.Content)
          } else {
            this.$message({
              type: "error",
              message: "请求数据失败",
            });
          }
        });
    },
    goNext(title){
      this.$router.push({
        name:"exchangeDetail",
        query:{
            title:title,
        }
      })
    },
    // 返回列表
    backList() {
      this.$router.push({
        name:"jxResearchInstitute",
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/base.less";

.exchangeDetail {
  width: 100%;
  color: #333;
  line-height: 1.7;


  .section {
    .w1200 {
      height: auto;
    }
    .content {
      div {
        text-align: left;
      }
      h2 {
        color: #333;
      }
      label {
        color: #c1c1c1;
        border-bottom: 1PX solid #D2D2D2;
      }
      p {
        text-align: left;
      }
      .videoDiv {
          width: 100%;
          video{
            width: 760PX;
          }
        }
    }
    .bottom-slide {
      border-bottom: 1PX solid #D2D2D2;
      a.return-a {
        color: #969696;
      }
      a.next-a,
      a.down-a {
        color: #0068b7;
      }
      a.down-a:before {
        content: "";
        background: url(../../assets/images/art-d.png) center center no-repeat;
        background-size: cover;
      }
    }
  }

  @media only screen and (min-width: 960px) {
    .section {
      .content {
        padding-top: 130PX;
        h2 {
          width: 970PX;
          font-size: 24PX;
          padding-top: 32PX;
          padding-bottom: 20PX;
        }
        label {
          width: 970PX;
          font-size: 16PX;
          padding-bottom: 20PX;
          margin-bottom: 20PX;
        }
        p {
          width: 970PX;
        }
      }
      .bottom-slide {
        margin-top: 70PX;
        padding: 16PX 60PX;
        margin-bottom: 20PX;
        a {
          font-size: 14PX;
        }
        a.return-a {
          margin-right: 50PX;
        }
        a.down-a:before {
          width: 14PX;
          height: 16PX;
        }
      }
    }
  }
  @media screen and (max-width:959px) and (min-width:320px) {
    .section {
      .content {
        padding-top: 3.52rem;
        h2 {
          width: 100%;
          font-size: 1.12rem;
          padding-top: 1.28rem;
          padding-bottom: .8rem;
        }
        label {
          width: 100%;
          font-size: .96rem;
          padding-bottom: .96rem;
          margin-bottom: .96rem;
        }
        p {
          width: 970PX; //width: 100%;
        }
        
        .videoDiv {
          width: 100%;
          video{
            width: 100%;
          }
        }
      }
      .bottom-slide {
        -webkit-box-lines: multiple;
        box-lines: multiple;
        flex-wrap: wrap;
        -webkit-flex-wrap: wrap;
        -moz-flex-wrap: wrap;
        webkit-box-align: start;
        -moz-align-items: flex-start;
        -webkit-align-items: flex-start;
        align-items: flex-start;
        margin-top: 2.4rem;
        padding: 0.73rem 1.44rem;
        margin-bottom: 0.8rem;
        .link-ul {
          -moz-box-lines: multiple;
          -webkit-box-lines: multiple;
          box-lines: multiple;
          flex-wrap: wrap;
          -webkit-flex-wrap: wrap;
          -moz-flex-wrap: wrap;
          a.return-a {
            margin-right: 1.2rem;
            font-size: .96rem;
          }
          a {
            font-size: .96rem;
            line-height: 2;
          }
        }
        a.down-a:before {
          width: .96rem;
          height: 16PX;
        }
      }
    }
  }
}
</style>